var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['detail-css mr-2', _vm.typeClassName(_vm.type)]},[_vm._v(" "+_vm._s(_vm.typeName(_vm.type))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }